import { FC } from 'react';
import getClassNames from 'src/common/utils/getClassNames';
import classNames from 'classnames';
import styles from './CheckDecorator.module.scss';

export type CheckDecoratorProps = {
  children: React.ReactNode;
  className?: string;
  disabled?: boolean;
  size?: 'small' | 'medium';
};

const CheckDecorator: FC<CheckDecoratorProps> = ({
  children,
  className,
  disabled,
  size = 'medium',
}) => (
  <span className={getClassNames(styles, 'root', classNames(className, size))}>
    {children}
    <span className={getClassNames(styles, 'checkMark', classNames(size, { disabled }))} />
  </span>
);

export default CheckDecorator;
